import {
  Component, OnInit, ElementRef, ViewChild, AfterViewChecked, ChangeDetectionStrategy, ChangeDetectorRef,
  AfterViewInit, OnDestroy
} from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { ioService } from '../../service/io.service';
import { eventEmitterService } from '../../service/eventEmitter.service';
import { environment } from '../../../environments/environment';
import { PostFilterService } from '../../service/post-filter.service';
import { GroupService } from '../../service/group.service';

declare var $: any;

@Component({
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.css'],
})
export class ChatComponent implements OnInit, AfterViewInit {

  // Declared all variables
  apiUrl = environment.apiUrl;
  s3apiUrl = environment.s3BucketApi;
  allOnlineUsers = [];
  title = 'Chat Application';
  message = '';
  messages = [];
  onlineUsers = [];
  activeUser;
  userId;
  toUsers;
  touser = { firstName : '', lastName : '', address : ''};
  socketId;
  group = { name : '', description : '' };
  messageToSend: string;
  showNewMsg = false;
  totalMsg = 0;
  connectedRooms = [];
  connectedRoomsWithUsers = [];
  onlineUsersLists = [];

  chatLength = 0;
  openChat = 0;
  removedUser = '';
  removedUserRoomId = '';
  visibleChatWindow = [];
  currentPage;

  stock;
  caption;
  files = [];
  selectedFileType;
  roomId; toUserId;
  imageSrc = [];
  error;
  isButtonEnabled = false;
  dateUpdater = '?ver=' + Date.now();
  set_clearTimeInterval;
  isLoading = false;
  uploadButtonToShow = true;
  activeChatType: string;

  isAllow = true;

  // Invoke all services files when this file intial load
  constructor(
    private _ioService: ioService,
    private  _groupService: GroupService,
    private chatService: eventEmitterService,
    private _changeDetector: ChangeDetectorRef,
    private link: PostFilterService
  ) {}

  // Get a reference element by using ViewChild
  @ViewChild('chatwindow', { static: false }) private chat_window: ElementRef;

  ngOnInit() {
    // Get current page Url for set status true/false to control socket listening
    this.link.currentMessage1.subscribe((url) => {
        if (url == '/messages' || url == '/groups' || url == '/allgroups'){
            this.currentPage = true;
        }else{
            this.currentPage = false;
        }
    });

    /*
    * Changed version to all images with present time for images render issue
    * Every one second it will change the version , After 8 second the interval will be cleared.
    */
    // this.link.currentMessage4.subscribe((res)=>{
    //     this.dateUpdater = '?ver='+Date.now();
    //     setTimeout(() => {
    //         this.dateUpdater = '?ver='+Date.now();
    //     }, 500);
    //     setTimeout(() => {
    //         this.dateUpdater = '?ver='+Date.now();
    //     }, 700);
    //     setTimeout(() => {
    //         this.dateUpdater = '?ver='+Date.now();
    //     }, 1000);
    //     setTimeout(() => {
    //         this.dateUpdater = '?ver='+Date.now();
    //     }, 1500);
    // });

    // Listening a event for open user chat window
    this.chatService.eventEmit$
        .subscribe(chatUser => {
            // For open a chat window
            if (this.userId != chatUser.id && chatUser.isOpenChat) {
              this.joinPrivate(chatUser.user);
            }

            // Listening removed user's information from residents page
            if (chatUser.removedUser != undefined && chatUser.removedUser != ''){
             this.removedUser = chatUser.removedUser;
             // this.chatService.triggerSocketService();
            }
        });

    // Subscribed all sockets emition results based on current logged in user's
    this.populateUsers();
    this.populateGroups();

    this.allOnlineUsers = this.onlineUsers;

  }

  private populateGroups() {
    this._groupService.group$
      .subscribe(message => {
        // console.log("GroupService Message", message);
        /*
        *  Get all groups based on current logged in user's
        */
        if (message['groups']) {
            const obj = { ...message['groups'], chatType : 'group'};
            /* If residents already present in online users list array,
            *  Only replaced last message with unreadMsg count value if user is not in active state
            */
            this.pushToUserListAndUpdateCounts(obj);
            // assign building filter users and sort them on the basis of their chat messages
            // this.assignBuildingFilterUsersAndSort();
            // TODO change sortUsersbasedOnlastMessage() to assignBuildingFilterUsersAndSort()
            this.sortUsersbasedOnlastMessage();
        }
        // Get the socket connection information
        if(message['session']) {
          this.updateSocketConnection(message);
        }
        // Get all messages and newly created message
        if(message['message']) {
          this.chatMessageListener(message);
        } else if (message['message'] == '') {
            this.messages = [];
        }
        if (!this._changeDetector['destroyed']) {
            this._changeDetector.detectChanges();
        }
      });
  }

  private populateUsers() {
    this._ioService.ioMessage$
      .subscribe(message => {
        /*
        *  Get all residents based on current logged in user's
        */
        if (message['users']) {
          const obj = { ...message['users'], chatType: 'user' };
          /* If residents already present in online users list array,
          *  Only replaced last message with unreadMsg count value if user is not in active state
          */
          this.pushToUserListAndUpdateCounts(obj);
          // assign building filter users and sort them on the basis of their chat messages
          // this.assignBuildingFilterUsersAndSort();
          // TODO change sortUsersbasedOnlastMessage() to assignBuildingFilterUsersAndSort()
          this.sortUsersbasedOnlastMessage();
        }
        // Get a socket connection information
        if (message['session']) {
          this.updateSocketConnection(message);
        }
        // Get all messages and newly created messages
        if (message['message']) {
          this.chatMessageListener(message);
        } else if (message['message'] == '') {
          this.messages = [];
        }

        // Online user list has been filtered for removed users
        // After filtering removed user no longer displayed on chat window
        if (this.removedUser) {
          let removedUserId = this.removedUser;
          setTimeout(() => {
            this.onlineUsers = this.onlineUsers.filter((v, i, a) => i !== a.findIndex((list) => (list.id == removedUserId)));
            this.removedUser = '';
            removedUserId = '';
            this.connectedRoomsWithUsers.forEach(function callback(roomValue, index, array) {
              if (roomValue.toUser.id == removedUserId) {
                $('#chatroom-' + roomValue.roomId).remove();
              }
            });
          }, 100);
        }

        if (!this._changeDetector['destroyed']) {
          this._changeDetector.detectChanges();
        }
      });
  }

  private pushToUserListAndUpdateCounts(obj: any) {
    // don't do anything for a group which is not private
    if (obj.chatType === 'group' && obj.private !== true) {
      return false;
    }

    if (this.onlineUsersLists.indexOf(obj.id) > -1) {
      // Update Read Status to connected users
      this.onlineUsers.forEach(user => {
        if (user.id == obj.id) {
          user.totalUnReadMsg = obj.totalUnReadMsg;
          user.lastMessage = obj.lastMessage;
          if (obj.chatType == 'group') {
            user.lastMessageCreatedDate = obj.lastMessageCreatedDate ? obj.lastMessageCreatedDate : obj.createdAt;
          } else {
            user.lastMessageCreatedDate = obj.lastMessageCreatedDate;
          }

          if (this.currentPage != true) {
            if (obj.totalUnReadMsg != undefined && obj.totalUnReadMsg > 0) {
              if (this.isAllow) {
                console.log(this.onlineUsers.length, 'index');
                this.isAllow = false;
                this.joinPrivate(obj);
                setTimeout(() => {
                  this.isAllow = true;
                }, 1000);
              }
            }
          }
        }
      });
      // TODO BUIDLING FILTERS
      // if(obj.buildingsFilter === true) {
      //   this.buildingsFilterUsersLists.push(obj.id);
      //   this.buildingsFilterUsers.push(obj);
      //   this.buildingsFilterUsersLists = this.buildingsFilterUsersLists.filter((v, i, a) => a.indexOf(v) === i);
      //   this.buildingsFilterUsers = this.buildingsFilterUsers.filter((v, i, a) => a.indexOf(v) === i);
      // }
    } else {
      /*
      * If a resident is not present in online users list array, then the user information pushed to this array
      * And also listen for new user's come up with this current logged in user's building
      */
      this.onlineUsersLists.push(obj.id);
      this.onlineUsers.push(obj);
      if (this.currentPage != true) {
        if (obj.totalUnReadMsg != undefined && obj.totalUnReadMsg > 0) {
          // this.joinPrivate(message["users"]);
        }
      }
    }
  }

  private chatMessageListener(message: any) {
    let messageContent = '';
    // Get all messages when user's connect to other user's via chat window
    if (message['message'] && message['allMessages']) {
      if (message['page'] == 'messages') {
        if(message.hasOwnProperty('group') && message['group'].private == true) {
          const groupId = message['groupId'];
          const group = message['group'];

          // When other user's chat window open, initially pushed all groups messages informations
          if (this.connectedRooms.indexOf(groupId) == -1) {
            this.connectedRooms.push(groupId);
            this.connectedRoomsWithUsers.push({ roomId : groupId, group: group, chatType: 'group'});
            this.messages.push({ roomId : groupId, group : group, chatType: 'group', messages : message['message'] });
          }

          /*
          * Set scroll to bottom for opened chat windows,
          * Also Max of 5 window display on screen ,
          * Otherwise old one replced with new one
          */
          setTimeout(() => {
            let ele = $('#chatroom-' + groupId).find('.main_msg_inner');
            let MsgWindowHeight = ele.find('.row').height();
            // ele.scrollTop(MsgWindowHeight);
            let allowable_legth = ($(window).width() - 70) / 323 - 1;
            let allowable_number = allowable_legth.toString()[0];
            if (this.visibleChatWindow.indexOf(groupId) < 0) {
              this.visibleChatWindow.push(groupId);
            }
            $('.pop_up_wrap').css('width', '100vw');
            if (this.visibleChatWindow.length > allowable_legth) {
              let care = this.visibleChatWindow[0];
              this.visibleChatWindow.splice($.inArray(this.visibleChatWindow[0], this.visibleChatWindow), 1);
              $('#chatroom-' + care).hide();
            }
          }, 100);
        } else {
          // Get Room Id
          const roomId = message['roomId'];
          const toUser = message['toUser'];
          // When other user's chat window open, initially pushed all messages informations
          if (this.connectedRooms.indexOf(roomId) == -1) {
            this.connectedRooms.push(roomId);
            this.connectedRoomsWithUsers.push({ roomId: roomId, toUser: toUser, chatType: 'user' });
            this.messages.push({ roomId: roomId, toUser: toUser, chatType: 'user', messages: message['message'] });
          }

          /*
          * Set scroll to bottom for opened chat windows,
          * Also Max of 5 window display on screen ,
          * Otherwise old one replced with new one
          */
          setTimeout(() => {
            let ele = $('#chatroom-' + roomId).find('.main_msg_inner');
            let MsgWindowHeight = ele.find('.row').height();
            // ele.scrollTop(MsgWindowHeight);
            let allowable_legth = ($(window).width() - 70) / 323 - 1;
            let allowable_number = allowable_legth.toString()[0];
            if (this.visibleChatWindow.indexOf(roomId) < 0) {
              this.visibleChatWindow.push(roomId);
            }
            $('.pop_up_wrap').css('width', '100vw');
            if (this.visibleChatWindow.length > allowable_legth) {
              let care = this.visibleChatWindow[0];
              this.visibleChatWindow.splice($.inArray(this.visibleChatWindow[0], this.visibleChatWindow), 1);
              $('#chatroom-' + care).hide();
            }
          }, 100);
        }
      }
    } else {
      // Listening newly created a message
      messageContent = message['message'];
      let roomId = null;
      if (message.hasOwnProperty('groupId')) {
        roomId = message.groupId;
      } else if (message.hasOwnProperty('roomId')) {
        roomId = message.roomId;
      }
      // Pushed newly created message based on room id
      if ((message['page'] == 'groups' || message['page'] == 'messages') && roomId != null) {
        this.messages.forEach(function callback(currentValue, index, array) {
          if (currentValue.roomId == roomId) {
            const messageExists = currentValue.messages.findIndex(msg => msg.id === message["message"].id) > -1;
            if (!messageExists) {
              currentValue.messages.push(message["message"]);
            }
          }
          currentValue.messages = currentValue.messages.filter((v, i, a) => a.indexOf(v) === i);
        });
      }
      //Update read status to this new message
      let ele = $('#chatroom-' + roomId).find('.main_msg_inner');
      let MsgWindowHeight = ele.find('.row').height();
      if (ele.is(':visible') === true) {
        this.updateMsgStatus(roomId);
        setTimeout(() => {
          $('.Firefox .main_msg_inner').scrollTop(999999);
        }, 300);
      }
      //    ele.scrollTop(MsgWindowHeight);
      if ((message['page'] == 'groups' || message['page'] == 'messages') && roomId != null) {
        if (message['message'].attachments != undefined && message['message'].attachments.length > 0) { // Check for attachments
          this.isLoading = false;
          $('#chatroom-' + roomId).find('.messages.custom-loading').hide();
        }
      }
    }
  }

  private updateSocketConnection(message: any) {
    this.socketId = message['session']['socketId'];
    this.userId = message['session']['user']['id'];
    this.activeUser = message['session']['user'];
  }

  private sortUsersbasedOnlastMessage() {
    // Re-arranged the users list array based on recent message time value.
    this.onlineUsers.sort((a, b) => {
      const currentLMCD = isNaN(Date.parse(a.lastMessageCreatedDate)) ? 0 : Date.parse(a.lastMessageCreatedDate);
      const nextLMCD = isNaN(Date.parse(b.lastMessageCreatedDate)) ? 0 : Date.parse(b.lastMessageCreatedDate);
      if (currentLMCD > nextLMCD) {
        return -1;
      }
      if (currentLMCD < nextLMCD) {
        return 1;
      }
    });
  }

   /*
   * Set the boolean value for display new message on chat window
   */
   showNewMessage(){
      this.showNewMsg = true;
   }

   /*
   * Update read status to all unread messages based on room id
   */
   updateMsgStatus(roomId){
      this._ioService.updateMsgStatus(roomId);
   }

   /*
   * Send a message from chat window
   * roomId, toUserId, textarea - passing params
   */
  sendChatMessage(room, textarea, e): void {
    // Check a empty value of current window textarea element
    let messageObject = {};
    if ($.trim($(textarea).val())) {

      // Build a object for send a new message
      if (room.hasOwnProperty('toUser')) {
        messageObject = {
          message : {
            to : room.toUser.id,
            roomId : room.roomId,
            content: $.trim(textarea.value),
            page : 'messages'
          }
        };
        // Call a service function to create a newly passed comment from chat window
        this._ioService.sendChatMessage(messageObject);
      }

      if (room.hasOwnProperty('group')) {
        messageObject = {
          message : {
            groupId : room.roomId,
            content: $.trim(textarea.value),
            page : 'groups'
          }
        };
        // Call a service function to create a newly passed comment from chat window
        this._groupService.sendGroupMessage(messageObject);
      }

        $(textarea).val('');
        e.preventDefault();
        setTimeout(() => {
          $('.main_msg_inner').scrollTop(999999);
        }, 300);
    }
  }

   /*
   * Make a private chat room for two connected users
   * to user object - passing params
   */
    joinPrivate( user: any, isSocket= null): void {

      // If toUser/Other resident's already present in this array, then just show it modal popup
      user.page = 'messages';
      $('.chatrooms .pop_up_chat').hide();

      // for (const roomsWithUsers of this.connectedRoomsWithUsers) {
      //   $('.chatrooms #chatroom-' + roomsWithUsers.roomId).show();

      // }
      this.connectedRoomsWithUsers.forEach(function callback(roomsWithUsers, index, array) {
        if (roomsWithUsers.hasOwnProperty('toUser')) {
          if (roomsWithUsers.toUser.id == user.id) {
            $('.chatrooms #chatroom-' + roomsWithUsers.roomId).show();
          }
        }
        if (roomsWithUsers.hasOwnProperty('group')) {
          if (roomsWithUsers.group.id == user.id) {
            $('.chatrooms #chatroom-' + roomsWithUsers.roomId).show();
          }
        }
      });

      this.showNewMsg = false;
      // this.messages = [];
      this.toUsers = user.id;
      this.touser = user;

      // Call a service function to connect other resident's via socket
      if (user.chatType == 'user') {
        this._ioService.joinPrivate(user);
      } else if (user.chatType === 'group') {
        this._groupService.joinPrivate(user);
      }

      this.openChat += 1;
      this.chatLength = length;

      // var i = 0;
      // var timer = setInterval(()=>{
      //   this.chatService.triggerSocketService();
      //   i++;
      //   if(i===2) clearInterval(timer);
      // }, 5000);

      if (user.chatType == 'user') {
        setTimeout(() => {
            $('.Firefox .main_msg_inner').scrollTop(999999);
            this.chatService.triggerSocketService('message');
        }, 1000);
      }

      if (user.chatType == 'group') {
        setTimeout(() => {
          $('.Firefox .main_msg_inner').scrollTop(999999);
          this.chatService.triggerSocketService('groupMsg');
        }, 1000);
      }
    }
    /*
    * Filtered users list based on user search
    */
    searchUser(searchUser){
       this.onlineUsers = this.chatService.filterUser(this.allOnlineUsers, 'firstName', searchUser);
    }

    /*
     * Resize chat a window
     */
    resizeOnlineChat(chat){
        $(chat).show();
    }

    /*
    * Minimize chat window
    */
    minimizeOnlineChat(chat, e, memlistChat){
        $(chat).toggle();
        $(memlistChat).addClass('sample');
        $(memlistChat).toggleClass('transform');
        e.stopPropagation();
    }

    /*
    * Resize chat a window
    */
    resizeChat(chat, chatWindowContainer){
        $(chat).toggle();
        $(chat).parent('.header_transform').find('.pop_header_wrap').toggleClass('transform');
    }
    /*
    * Minimize chat window
    */
    minimizeChat(chat, chatWindowContainer){
        $(chat).toggle();
        $(chat).parent('.header_transform').find('.pop_header_wrap').toggleClass('transform');
    }

    joinGroup(): void {
        this._ioService.joinGroup();
    }
    /*
    * Close chat window
    */
    leaveChat(chatRoom, toUserId , roomId){
        if (this.connectedRooms.indexOf(roomId) > -1){
            $(chatRoom).hide();
        }
    }
    onChange(event, roomId, recipientId, chatType) {
        this.uploadButtonToShow = true;
        let src = [];
        this.files = [];
        this.imageSrc = [];
        this.isButtonEnabled = false;

        let e = window.event || event;
        let target = e.target || e.srcElement;

        if (target.files.length > 0) {
              let Extension = target.files[0].name.substring(target.files[0].name.lastIndexOf('.') + 1).toLowerCase();
              let fileType = '';
              if (Extension == 'gif' || Extension == 'png' || Extension == 'bmp'
                || Extension == 'jpeg' || Extension == 'jpg') {
                fileType = 'image';
              }else{
                fileType = 'document';
              }
              target.files[0].extension = Extension;
              target.files[0].fileType = fileType;
              let fileSize = target.files[0].size / 1024 / 1024;

              if (this.selectedFileType == 'image'){
                if (fileType == 'image') {

                    if (fileSize <= 20){
                        this.error = null;
                        this.imageSrc = src;
                        for (let i = 0; i < target.files.length; i++) {
                            setupReader(target.files[i]);
                            this.files.push(target.files[i]);
                        }

                        this.roomId = roomId;
                        this.toUserId = recipientId;
                        this.activeChatType = chatType;
                    }else{
                        this.files = [];
                        this.uploadButtonToShow = false;
                        this.error = 'File size must not be more than 20 MB';
                    }
                    $('#chatFileModal').modal('show');
                }else{
                    this.files = [];
                    this.uploadButtonToShow = false;
                    this.error = 'Please select either a .jpeg, .jpg, or .png file'
                    $('#chatFileModal').modal('show');
                }

              }else if (this.selectedFileType == 'document'){

                if (fileType == 'document' && Extension == 'pdf') {

                    if (fileSize <= 20){
                        this.error = null;
                        this.imageSrc = ['../../../../assets/images/pdf.svg'];
                        for (let i = 0; i < target.files.length; i++) {
                            setupReader(target.files[i]);
                            this.files.push(target.files[i]);
                        }

                        this.roomId = roomId;
                        this.toUserId = recipientId;
                        this.activeChatType = chatType;
                    }else{
                       this.files = [];
                       this.uploadButtonToShow = false;
                       this.error = 'File size must not be more than 20 MB';
                    }
                    $('#chatFileModal').modal('show');
                }else{
                    this.files = [];
                    this.uploadButtonToShow = false;
                    this.error = 'Please select .pdf file format';
                    $('#chatFileModal').modal('show');
                }

              }

          }
          function setupReader(file) {
            let name = file.name;
            let reader = new FileReader();
            reader.onload = function(e) {
                // get file content
               src.push(reader.result);
            };
            return reader.readAsDataURL(file);
         }

    }

    uploadDocuments(){
        this.isButtonEnabled = true;
        const isGroup = this.activeChatType === 'group';
        const message = isGroup ? {
          to: this.toUserId,
          groupId: this.roomId,
          caption: this.caption,
          page: 'groups'
        } : {
          to: this.toUserId,
          roomId: this.roomId,
          caption: this.caption,
          page: 'message'
        };
        const submission: any = {
          message,
          file: this.files && this.files.length ? this.files[0] : null
        };
        if (!submission.file) {
          this.error = 'No file selected';
          return;
        }
        this.isLoading = true;
        let room = this.roomId;
        $('#chatroom-' + room).find('.messages.custom-loading').show();
        const upload$ = isGroup
          ? this._groupService.sendChatMessageWithFile(submission)
          : this._ioService.sendChatMessageWithFile(submission);
        upload$.subscribe((res) => {
            this.isLoading = false;
            $('#chatroom-' + room).find('.messages.custom-loading').hide();
        }, (error) => {
            this.isLoading = false;
            $('#chatroom-' + room).find('.messages.custom-loading').hide();
            console.error('Upload failed:', error);
        });
        $('#chatFileModal').modal('hide');
        $('#file-upload').val('');
        setTimeout(() => {
            $('.Firefox .main_msg_inner').scrollTop(999999);
        }, 300);
    }
    triggerImageUpload(chatImageUpload, type){
        this.selectedFileType = type;
        this.isButtonEnabled = false;
        $('#file-upload').val('');
        $(chatImageUpload).trigger('click');
    }

    // imageLoaderCheck(path, event){
    //     this.dateUpdater = '?ver='+Date.now();
    // }

    ngAfterViewInit(){

        let i = 0;
        const timer = setInterval(() => {
          this._ioService.registerSailsListener();
          this._groupService.getMyGroups();
            i++;
          if (i === 2){
              clearInterval(timer);
          }
        }, 1000);
    }
}
